// Ref: https://github.com/wellsjo/console.save
export class IOUtils {
    static saveDataURL(dataUrl: string, blobType: string, filename: string) {
        // create a phantom link element to download a Blob of data, then create
        // a mouse event to click the link to download the file.
        const e = document.createEvent('MouseEvents');
        const a = document.createElement('a');

        a.download = filename;
        a.href = dataUrl;
        a.dataset.downloadurl = [blobType, a.download, a.href].join(':');
        e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        a.dispatchEvent(e);
    }

    static saveBlob(blob: Blob | MediaSource, blobType: string, filename: string) {
        const dataUrl = window.URL.createObjectURL(blob);
        IOUtils.saveDataURL(dataUrl, blobType, filename);
    }

    public static saveJson(obj: any, filename: string) {
        if (!obj) {
            console.error('console.saveJson: No data.');
            return;
        }
        if (!filename) filename = 'console.json';

        let data: string;
        if (typeof obj === 'object') {
            data = JSON.stringify(obj, undefined, 4);
        }
        else
            data = obj as string;

        // use utf-8 instead the default encoding (ansi)
        const uint8 = new Uint8Array(data.length);
        for (let i = 0; i < uint8.length; i++) {
            uint8[i] = data.charCodeAt(i);
        }

        const blobType = 'text/json';
        const blob = new Blob([uint8], {
            type: blobType
        });
        IOUtils.saveBlob(blob, blobType, filename);
    }

}